/**
 * React Icons Configuration
 *
 * Centralized configuration for all supported React Icons.
 * Supports icons from Font Awesome, Hero Icons, Material Design, and Box Icons.
 */

import * as FaIcons from 'react-icons/fa'
import * as HiIcons from 'react-icons/hi'
import * as Hi2Icons from 'react-icons/hi2'
import * as MdIcons from 'react-icons/md'
import * as BiIcons from 'react-icons/bi'
import React from 'react'

// Combine all icon libraries
export const REACT_ICONS: Record<string, React.ComponentType<{ className?: string }>> = {
  ...FaIcons,
  ...HiIcons,
  ...Hi2Icons,
  ...MdIcons,
  ...BiIcons,
} as Record<string, React.ComponentType<{ className?: string }>>

// Filter out non-icon exports and sort
export const ICON_NAMES = Object.keys(REACT_ICONS)
  .filter(
    (name) =>
      name.startsWith('Fa') ||
      name.startsWith('Hi') ||
      name.startsWith('Md') ||
      name.startsWith('Bi')
  )
  .sort()
